import React, { Component } from 'react'
import { Container, Row, Col, Card, Button, Image, Modal, Form, Accordion } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import '../previous_paper_exams/_previousPaperExams.scss';

import { isMobile } from "react-device-detect";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import gql from "graphql-tag";
import { withRouter, Link } from "react-router-dom";
import UserRestrictionAlert from "../home/UserRestrictionAlert";
import moment from 'moment';
import PreloaderTwo from "../preloader/PreloaderTwo";
import ChapterAnalysis from './chapter_analysis';

const GET_ADAPTIVE_QUESTIONS = gql`
query($student_user_exam_id: Int!, $type: String, $exam_paper_id: Int, $institution_id: Int!) {
  getAdaptiveQuestions(student_user_exam_id: $student_user_exam_id, type: $type, exam_paper_id: $exam_paper_id, institution_id: $institution_id) {
    id
    name
    exam_type
    no_of_sets
      syllabus{
      subject
      chapters {
        id
        name
      }
      topics{
        id
        name
      }
    }

    start_time
    end_time
    is_completed
    filename
    session_id
    exam_name
    class
    section
    branch
    type
    class_id
    sub_exam_type
    exam_model_id
    total_question_count
    proctoring_required
    schedule_sub_type_id
    schedule_type_id
  }
}
`;

const FETCH_ADAPTIVE_EXAMSCHEDULESUBTYPES = gql` 
query($institution_id: Int!,$type: String) {
    getExamScheduleSubTypeQuestions(institution_id: $institution_id,type: $type){
        schedule_type_id
        schedule_sub_type_id
        schedule_sub_type
    }
}

`;
// const STUDENT_ADAPTIVE_EXAM = gql`
//   mutation(
//     $params:StudentAdaptiveExam  
//     ) {
//         studentAdaptiveExam(
//         params: $params
//      )
//   }
// `;




class AdaptiveExamsHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: 'adaptive',
            expandval: "",
            userRestionModalShow: false,
            subtype: "1",
            showTopicModel: false,
            selectedSyllabus: [],
            selectedScheduleSubType: null,
            chapterAnalysisModal: false,
        };
    }

    onSelect = key => {
        this.setState({ selected: key });
        this.props.adaptiveQuestionsData.refetch({ type: key });
    };

    getblocks = (indexVal) => {
        if (this.state.expandval !== indexVal.toString()) {
            this.setState({ expandval: indexVal.toString() })
        }
        else {
            this.setState({ expandval: "" })
        }
    }

    startExam = (data) => {

        let examname = "";
        if (data.short_name != "" && data.short_name != undefined) {
            examname = (data.exam_name || data.name) + " (" + data.short_name + ")";
        }
        else {
            examname = data.exam_name || data.name;
        }

        localStorage.setItem("sessionid", data.session_id ? data.session_id.toString() : "0");
        localStorage.setItem("type", "Schedule Exam");
        localStorage.setItem("stype", "schedule_exam");
        localStorage.setItem("exam_paper_id", data.id);
        localStorage.setItem("etype", "schedule");
        localStorage.setItem("examname", examname);
        localStorage.setItem("subexamtype", this.state.subtype);
        localStorage.setItem("examtype_pattern", "college_schedule_exam");

        if (isMobile == true && Cookies.get("institution_id") == 30) {
            window.location.replace("/student/subject/exam");
        } else {
            window.open("/student/subject/exam", "_blank")
        }


    }

    gotoResults = (data) => {
        let examname = "";
        if (data.short_name != "" && data.short_name != undefined) {
            examname = (data.exam_name || data.name) + " (" + data.short_name + ")";
        }
        else {
            examname = data.exam_name || data.name;
        }

        this.props.history.push({
            pathname: "/student/subject/exam-result",
            state: {
                sessionid: data.session_id,
                examtype: "adaptive_exam",
                examname: examname
            }
        });
    }

    restrictionPopup = () => {
        this.setState({
            userRestionModalShow: true
        });
    }
    handleScheduleTypeChange = (item) => {
        this.setState({
            selectedScheduleType: Number(item.schedule_type_id),
            selectedScheduleSubType: Number(item.schedule_sub_type_id)
        });
    };


    componentDidUpdate(prevProps) {
        const data = this.props.adaptiveScheduledTypesData.getExamScheduleSubTypeQuestions;

        if (
            data &&
            data.length > 0 &&
            prevProps.adaptiveScheduledTypesData.getExamScheduleSubTypeQuestions !== data &&
            !this.state.selectedScheduleSubType
        ) {
            this.setState({
                selectedScheduleType: Number(data[0].schedule_type_id),
                selectedScheduleSubType: Number(data[0].schedule_sub_type_id)
            });
        }
    }
    render() {
        const { getAdaptiveQuestions, loading } = this.props.adaptiveQuestionsData;
        const adaptiveScheduledTypesData = this.props.adaptiveScheduledTypesData.getExamScheduleSubTypeQuestions;
        const { selected } = this.state;
        console.log("adaptiveScheduledTypesData", adaptiveScheduledTypesData);
        if (loading) return <PreloaderTwo />;

        let examsList = getAdaptiveQuestions || [];

        if (this.state.selectedScheduleSubType) {
            examsList = examsList.filter(
                exam =>
                    exam.schedule_type_id === this.state.selectedScheduleType &&
                    exam.schedule_sub_type_id === this.state.selectedScheduleSubType
            );
        }

        return (
            <section className="previousPaperExams">
                <div className='typeSelection'>
                    <Container>
                        <Row className="mb-4">
                            <Col sm={8}>
                                <h1>Adaptive Exams</h1>
                            </Col>
                        </Row>
                        {/* <Row className="mb-3">
                            <Col className="d-flex">
                                <Button
                                    variant={selected === 'adaptive' ? 'primary' : 'outline-primary'}
                                    onClick={() => this.onSelect('adaptive')}
                                    className="mr-3"
                                >
                                    Adaptive
                                </Button>
                                <Button
                                    variant={selected === 'remedial' ? 'primary' : 'outline-primary'}
                                    onClick={() => this.onSelect('remedial')}
                                >
                                    Remedial
                                </Button>
                            </Col>
                        </Row> */}
                        {/* {selected === "adaptive" && ( */}
                        <Row className="form-row">
                            <Col sm={6}>
                                <Form.Group>
                                    {adaptiveScheduledTypesData && adaptiveScheduledTypesData.length > 0 && adaptiveScheduledTypesData.map((item) => (
                                        <Form.Check
                                            key={item.schedule_sub_type_id}
                                            id={`schedule-${item.schedule_sub_type_id}`}
                                            inline
                                            type="radio"
                                            name="adaptive_schedule_type"
                                            label={item.schedule_sub_type}
                                            checked={
                                                this.state.selectedScheduleSubType === Number(item.schedule_sub_type_id)
                                            }
                                            onChange={() => this.handleScheduleTypeChange(item)}
                                        />
                                    ))}
                                </Form.Group>
                            </Col>

                            <Col sm={6} className='d-flex justify-content-end'>
                                <button type="button" className="btn-custom-blue float-right f-12 text-uppercase btn btn-primary"
                                    onClick={() => this.setState({
                                        chapterAnalysisModal: true
                                    })}>View Performance</button>
                            </Col>
                        </Row>
                        {/* )} */}
                    </Container>

                    {examsList.length === 0 ? (
                        <div className="text-center mt-5">No Exams found.</div>
                    ) : (
                        <Container className="mt-4">
                            <Row>
                                {examsList.map((exam, idx) => (
                                    <Col key={idx} sm={4} className='mt-2'>
                                        <Card className='border_pad_card' style={{ cursor: "pointer" }}>
                                            <Card.Body className='p-2'>
                                                <h6 className='mt-2 mb-2 ml-1'>{exam.name}</h6>
                                                <p className='ml-1 mb-1 f-12'>Exam: <b>{exam.exam_name}</b></p>

                                                <p className='ml-1 mb-1 f-12'>Start Time: <b>{moment.unix(exam.start_time).format("LLL")}</b></p>

                                                <div className='mt-3 mb-1 ml-1 durTxt'>
                                                    <button type="button" className="btn-custom-dark float-left f-12 btn btn-secondary" onClick={() => this.setState({
                                                        showTopicModel: true,
                                                        selectedSyllabus: exam.syllabus || []
                                                    })}>
                                                        Syllabus
                                                    </button>
                                                    {exam.is_completed !== 0 && exam.session_id !== 0 ? (
                                                        <button type="button" className="btn-custom-blue float-right f-12 text-uppercase btn btn-primary" onClick={() => this.gotoResults(exam)}>
                                                            Results
                                                        </button>
                                                    ) : (
                                                        <button type="button" className="btn-custom-blue float-right f-12 text-uppercase btn btn-primary" onClick={() => this.startExam(exam)}>
                                                            Start Test
                                                        </button>
                                                    )}
                                                    <div className="clearfix"></div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Container>
                    )}

                    {this.state.showTopicModel && <Modal show={this.state.showTopicModel} onHide={() => this.setState({ showTopicModel: false })}
                        size="lg" aria-labelledby="example-modal-sizes-title-lg">
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-lg">Syllabus</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-4" style={{ height: 522, overflowY: 'auto' }}>

                            <ul className="list-unstyled m-0 p-0">
                                {this.state.selectedSyllabus?.map((item, i) => (
                                    <li key={i} className="mb-3">
                                        <div>
                                            <div className="text-primary font-weight-bold">
                                                Subject: {item.subject}
                                            </div>
                                            <div className="text-primary font-weight-bold">
                                                Chapters: {item.chapters?.map((chapter, c) => chapter.name).join(", ")}
                                            </div>

                                            {item.topics && item.topics.length > 0 && (
                                                <div className="ml-3 mt-2">
                                                    <div className="text-warning">Topics:</div>
                                                    <ul>
                                                        {item.topics.map((topic, t) => (
                                                            <li key={t}>{topic.name}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                            {/* <h5 className="text-danger">Chapters Data</h5> */}
                        </Modal.Body>
                    </Modal >}
                </div>

                <UserRestrictionAlert
                    show={this.state.userRestionModalShow}
                    onHide={() => this.setState({ userRestionModalShow: false })}
                />

                <ChapterAnalysis
                    show={this.state.chapterAnalysisModal}
                    onHide={() => this.setState({ chapterAnalysisModal: false })}
                />
            </section>
        )
    }
}  

export default withRouter(compose(
    graphql(GET_ADAPTIVE_QUESTIONS, {
        name: "adaptiveQuestionsData",
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institution_id")) || 0,
                student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                type: "adaptive",
                exam_paper_id: 0
            }
        })
    }),
    graphql(FETCH_ADAPTIVE_EXAMSCHEDULESUBTYPES, {
        name: "adaptiveScheduledTypesData",
        options: () => ({
            variables: {
                institution_id: parseInt(Cookies.get("institution_id")) || 0,
                type: "Adaptive_Exam"
            }
        })
    }),
)(AdaptiveExamsHome));
